import InputsCreatorUniversal from "../../../../hooks/inputCreatorUniversal";

import styles from "./certificateInfo.module.css";
import innerStyles from "../../../../components/AdministrativeProcedures/commonComponents/universalInputComponent/universalInputComponent.module.css";

export default function CertificateInfo({
  fieldsOptions,
  inputData,
  register,
  newData,
  control,
  setValue,
  mode,
  errors,
  clearErrors,
  handleCustomButton,
  getValues,
  setError,
}) {
  return (
    <div className={styles[`certificate-info-${mode}`]}>
      {Object.values(fieldsOptions).map((item) => {
        if (item.needInForm) {
          if (mode === "view" || item.readOnly) {
            return item?.caption ? (
              <p className={`${styles["secondary-caption"]} ${styles[`box-${item.key}`]}`}>{item.caption}</p>
            ) : (
              <div className={`${styles["text-block"]} ${styles?.[`box-${item.key}`]}`}>
                <p className={styles[`${item.cssKey}-option-label`]}>{item.label}</p>
                <p className={styles[`${item.cssKey}-option-value`]}>
                  {item.type === "selectWithSearch"
                    ? item.options.find((elem) => elem.value === inputData?.[item.key])?.label || "—"
                    : item.type === "date" && inputData?.[item.key]
                    ? inputData?.[item.key].split("-").reverse().join(".")
                    : inputData?.[item.key] || "—"}
                </p>
              </div>
            );
          } else {
            return item?.caption ? (
              <p className={`${styles["secondary-caption"]} ${styles[`box-${item.key}`]}`}>{item.caption}</p>
            ) : (
              <InputsCreatorUniversal
                option={item}
                styles={innerStyles}
                register={register}
                newData={newData}
                control={control}
                setValue={setValue}
                mode={mode}
                errors={errors}
                clearErrors={clearErrors}
                handleCustomButton={handleCustomButton}
                getValues={getValues}
                setError={setError}
              />
            );
          }
        }
      })}
    </div>
  );
}
